import {Polygon} from './polygon';
import {Spot} from './spot';
import {GeoGroupData} from './geo-group-data';
import LatLngBoundsLiteral = google.maps.LatLngBoundsLiteral;

export class GeoGroup extends GeoGroupData {
  polygons: Polygon[] = [];
  spots: Spot[] = [];
  bounds: LatLngBoundsLiteral = null;
}
